import { RefObject, useLayoutEffect, useState } from "react";
/**
 * Tracks the viewport Y position of an anchor element's bottom edge.
 * Uses ResizeObserver so accordion/layout changes stay in sync.
 */
export function useAnchorBottom(anchorRef: RefObject<HTMLElement | null> | undefined, enabled: boolean): number | null {
  const [bottom, setBottom] = useState<number | null>(null);
  useLayoutEffect(() => {
    if (!enabled || !anchorRef?.current) {
      setBottom(null);
      return;
    }
    const element = anchorRef.current;
    const update = () => {
      setBottom(element.getBoundingClientRect().bottom);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    window.addEventListener("resize", update);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [anchorRef, enabled]);
  return bottom;
}
